import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthenticatedUser } from '../../api/auth/authenticated-user.model';
import { Organization } from '../../api/organization/organization.model';
import { CheckOutActivity } from '../../api/check-in-check-out/check-out-activity.model';
import { CheckInActivity } from '../../api/check-in-check-out/check-in-activity.model';

@Injectable({
	providedIn: 'root'
})
export class BroadcastService
{
	organizationChanged = new Subject<Organization>();                                      // Sent when Global Admin selects an Organization from header drop-down.
	organizationListChanged = new Subject();                                                // Sent when organization list is updated

	userSignedIn = new Subject<AuthenticatedUser>();                                                  // Called when user signs out. Allows subscribers to take appropriate action (e.g., clear caches)
	userSignedOut = new Subject<string | null>();                                                  // Called when user signs out. Allows subscribers to take appropriate action (e.g., clear caches)

	checkOutAnnounced = new Subject<CheckOutActivity>();
	newCheckInActivity = new Subject<CheckInActivity[]>();
	removedCheckedInActivity = new Subject<number[]>();
	newCheckOutActivity = new Subject<CheckOutActivity[]>();
	removedCheckedOutActivity = new Subject<number[]>();
	newScheduledCheckOutActivity = new Subject<CheckOutActivity[]>();
	removedScheduledCheckOutActivity = new Subject<number[]>();
	newUpcomingScheduledCheckOutActivity = new Subject<CheckOutActivity[]>();
	removedUpcomingScheduledCheckOutActivity = new Subject<number[]>();

	constructor()
	{
	}
}
